interface NavAttributes {
  [propName: string]: any;
}
interface NavWrapper {
  attributes: NavAttributes;
  element: string;
}
interface NavBadge {
  text: string;
  variant: string;
}
interface NavLabel {
  class?: string;
  variant: string;
}

export interface NavData {
  name?: string;
  url?: string;
  icon?: string;
  badge?: NavBadge;
  title?: boolean;
  children?: NavData[];
  variant?: string;
  attributes?: NavAttributes;
  divider?: boolean;
  class?: string;
  label?: NavLabel;
  wrapper?: NavWrapper;
}

export const navItems: NavData[] = [
  {
    title: true,
    name: 'Monitoramento'
  },
  {
    name: 'Painel',
    url: '/dashboard',
    icon: 'icon-screen-desktop',
    badge: {
      variant: 'info',
      text: 'Painel'
    }
  },
  {
    name: 'Logs',
    url: '/components/logs',
    icon: 'icon-info',
    badge: {
      variant: 'info',
      text: 'Logs'
    }
  },
  {
    title: true,
    name: 'Relatórios'
  },
  {
    name: 'E-Commerce X ERP',
    url: '/components/trayxsap',
    icon: 'icon-book-open'
  },
  {
    name: 'Pedidos Não Integrados',
    url: '/components/pedidosnaointegrados',
    icon: 'icon-book-open'
  }

];


export const navItemsOperConciliacao: NavData[] = [
  {
    title: true,
    name: 'Conciliação'
  },
  {
    name: 'Conciliação',
    url: '/components/conciliacao',
    icon: 'icon-people'
  },
  {
    name: 'Histórico Conciliação',
    url: '/components/histconciliacao',
    icon: 'icon-file'
  }
];

export const navItemsAdminConciliacao: NavData[] = [
  {
    title: true,
    name: 'Conciliação'
  },
  {
    name: 'Taxas Administrativas',
    url: '/components/taxasadministrativas',
    icon: 'icon-credit-card'
  },
  {
    name: 'Conciliação',
    url: '/components/conciliacao',
    icon: 'icon-calculator'
  },
  {
    name: 'Histórico Conciliação',
    url: '/components/histconciliacao',
    icon: 'icon-book-open'
  }
];

export const navItemsAdmin: NavData[] = [
  {
    title: true,
    name: 'Monitoramento'
  },
  {
    name: 'Painel',
    url: '/dashboard',
    icon: 'icon-screen-desktop',
    badge: {
      variant: 'info',
      text: 'Painel'
    }
  },
  {
    name: 'Logs',
    url: '/components/logs',
    icon: 'icon-info',
    badge: {
      variant: 'info',
      text: 'Logs'
    }
  },
  {
    title: true,
    name: 'Cadastros'
  },
  {
    name: 'Usuarios Monitor',
    url: '/components/usuariosmonitor',
    icon: 'icon-people'
  },
  {
    name: 'Usuarios API',
    url: '/components/usuariosapi',
    icon: 'icon-people'
  },
  {
    name: 'Roteamento',
    url: '/components/roteamento',
    icon: 'icon-link'
  },
  {
    name: 'Passos Roteam...',
    url: '/components/passosroteamento',
    icon: 'icon-link'
  },
  {
    name: 'Endpoints',
    url: '/components/endpoint',
    icon: 'icon-link'
  },
  {
    name: 'Clientes/Fornecedor',
    url: '/components/cliente',
    icon: 'icon-people'
  },
  {
      name: 'Ambientes',
      url: '/components/ambiente',
      icon: 'icon-cloud-upload'
    },
  {
    name: 'Conf do Painel',
    url: '/components/confpainel',
    icon: 'icon-settings'
  },
  {
    name: 'Formato de Msg',
    url: '/components/formatomensagem',
    icon: 'icon-puzzle'
  },
  {
    name: 'Tipo de Interface',
    url: '/components/tipointerface',
    icon: 'icon-paper-plane'
  },
  {
    name: 'Integração',
    url: '/components/integracao',
    icon: 'icon-share'
  },
  {
    name: 'Modelo Mediador',
    url: '/components/modelomediador',
    icon: 'icon-layers'
  },
  {
    name: 'Tipo de Comunicação',
    url: '/components/tipocomunicacao',
    icon: 'icon-phone'
  },
  {
    name: 'Tipo de Mediador',
    url: '/components/tipomediador',
    icon: 'icon-compass'
  },
  {
    name: 'Tipo de Processame...',
    url: '/components/tipoprocessamento',
    icon: 'icon-organization'
  },
  {
    name: 'De/Para Generic',
    url: '/components/deparageneric',
    icon: 'icon-directions'
  },
  {
    title: true,
    name: 'Conciliação'
  },
  {
    name: 'Taxas Administrativas',
    url: '/components/taxasadministrativas',
    icon: 'icon-wallet'
  },
  {
    name: 'Conciliação',
    url: '/components/conciliacao',
    icon: 'icon-docs'
  },
  {
    name: 'Histórico Conciliação',
    url: '/components/histconciliacao',
    icon: 'icon-book-open'
  },
  {
    title: true,
    name: 'Relatórios'
  },
  {
    name: 'E-Commerce X ERP',
    url: '/components/trayxsap',
    icon: 'icon-book-open'
  },
     {
       name: 'Pedidos Não Integrados',
       url: '/components/pedidosnaointegrados',
       icon: 'icon-ban'
     },
  {
    name: 'Alertas das Integrações',
    url: '/components/relatorio-integracao',
    icon: 'icon-ban'
  }


];

